import { IconButton } from "@dropbox/dig-components/buttons";
import { Text } from "@dropbox/dig-components/typography";
import { UIIcon } from "@dropbox/dig-icons";
import { AddLine, SendLine } from "@dropbox/dig-icons/assets";
import { SearchFilters } from "@mirage/mosaics/SearchPage";
import useConnectors from "@mirage/service-connectors/useConnectors";
import { KeyCodes } from "@mirage/shared/util/constants";
import styles from "./DebuggerHeader.module.css";

import type { SearchFilter } from "@mirage/shared/search/search-filters";
export const DEBUG_INPUT_ID = "search-debugger-input";

interface DebuggerHeaderProps {
  query: string;
  onQueryChange: (query: string) => void;
  onSubmit: () => void;
  activeFilters: SearchFilter[];
  onFilterChange: (filters: SearchFilter[]) => void;
  showAddPanelButton: boolean;
  onAddPanel: () => void;
  loading: boolean;
}

export const DebuggerHeader = ({
  query,
  onQueryChange,
  onSubmit,
  activeFilters,
  onFilterChange,
  showAddPanelButton,
  onAddPanel,
  loading,
}: DebuggerHeaderProps) => {
  const { connectors } = useConnectors();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === KeyCodes.enter) {
      onSubmit();
    }
  };

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.logoSection}>
        <div className={styles.logoIcon}>
          <div className={styles.splitIcon}>
            <div className={styles.splitLeft}></div>
            <div className={styles.splitRight}></div>
          </div>
        </div>
        <div className={styles.logoText}>
          <div className={styles.logoTitle}>
            <Text size="large">Dash Split View</Text>
            <div className={styles.internalBadge}>
              <Text size="small">Internal</Text>
            </div>
          </div>
          <Text size="medium" color="subtle">
            Search Evaluation
          </Text>
        </div>
      </div>

      <div className={styles.header}>
        <div className={styles.container}>
          <div className={styles.inputContainer}>
            <input
              id={DEBUG_INPUT_ID}
              className={styles.input}
              type="text"
              placeholder="Find anything..."
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              onKeyDown={handleKeyDown}
              disabled={loading}
            />
            <IconButton
              variant="transparent"
              onClick={onSubmit}
              disabled={loading}
            >
              <UIIcon src={SendLine} />
            </IconButton>
          </div>

          <div className={styles.filtersContainer}>
            <SearchFilters
              connectors={connectors}
              browserHistoryConnectors={[]} // Not including here as it's probably not needed for debugging relevance things
              activeFilters={activeFilters}
              onFilterChange={onFilterChange}
              logTelemetry={false} // Prevent this debug page from messing with PAP events
            />
            {showAddPanelButton && (
              <div className={styles.plusButtonContainer}>
                <IconButton
                  variant="outline"
                  size="small"
                  onClick={onAddPanel}
                  disabled={loading}
                >
                  <UIIcon src={AddLine} />
                </IconButton>
                <Text size="small">Add experiment</Text>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
